'use strict';

import Backbone from 'backbone';
import $ from 'jquery';
import config from '../../js/config';
import Analytics from '../Analytics/Analytics';
import userService from '../../services/CartUserService';

const LoginSplashView = Backbone.View.extend({
  events: {
    'click .Button': 'redirectLinkClick',
    'change .LoginSplash-select': 'updateComponentsUrlLink'
  },
  initialize: function initialize() {
    this.$el.$regionSelection = this.$el.find('.LoginSplash-select');
    this.$el.$createAccountMyArrow = this.$el.find('.LoginSplash-myArrow');
    this.baseComponentsUrl = this.$el.$createAccountMyArrow.attr('href');
    this.$el.$createAccountMyArrow.attr('href', this.buildComponentsUrl());
    this.myArrowRedirectClass = 'LoginSplash-myArrow';
    this.updateAnalyticsLabelAttribute();
  },
  buildComponentsUrl: function() {
    return this.baseComponentsUrl + '?region=' + this.$el.$regionSelection.val();
  },
  redirectLinkClick: function(e) {
    // Set the region cookie if the user is redirecting to components
    if (e.currentTarget.className.indexOf(this.myArrowRedirectClass) > -1) {
      userService.setRegionCookie(this.$el.$regionSelection.val());
    }
    $(e.currentTarget).addClass(config.classes.loadingClass + ' ' + config.classes.isWhite);
  },
  updateComponentsUrlLink: function() {
    this.$el.$createAccountMyArrow.attr('href', this.buildComponentsUrl());
    this.updateAnalyticsLabelAttribute();
  },
  updateAnalyticsLabelAttribute: function() {
    var splitString = this.$el.$createAccountMyArrow.attr(Analytics.LABEL_TAG).split(Analytics.SEPARATOR);
    var labelValue = splitString[0] + Analytics.SEPARATOR + this.$el.$regionSelection.val();
    Analytics.setLabelAttribute(this.$el.$createAccountMyArrow, labelValue);
  }
}, {
  create: function($parent) {
    $parent.find('.LoginSplash').each(function(n, el) {
      new LoginSplashView({
        el: el
      });
    });
  }
});

module.exports = LoginSplashView;



// WEBPACK FOOTER //
// ./assets/components/LoginSplash/LoginSplash.js